export const IMAGES = [
  { src: "https://i.ibb.co/PN3Vz9s/img30.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/PN3Vz9s/img30.jpg", thumbnail: "" },
 
];

